var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"parent":"sms_settings"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('BaseDatepickerInput',{attrs:{"ranged":""},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})]},proxy:true}])}),_c('WhiteTable',{attrs:{"rows":_vm.history,"columns":[
        {
          text: _vm.$t('sms_history.col_date'),
          key: 'created_at',
          width: 120,
          format: 'date',
        },
        {
          text: _vm.$t('sms_history.col_time'),
          key: 'created_at',
          width: 120,
          format: 'time',
        },
        {
          text: _vm.$t('sms_history.col_type'),
          width: 200,
          key: 'source_type',
          renderer: function (v) { return _vm.$t('balance_table.sms_types.'+v.source_type); }
        },
        {
          text: _vm.$t('sms_history.col_text'),
          key: 'content',
        },
        {
          text: _vm.$t('sms_history.col_segments'),
          width: 100,
          key: 'segments_count',
        },
        {
          text: _vm.$t('sms_history.col_cost'),
          key: 'public_cost_usd',
          format: 'suffix',
          suffix: '$',
          width: 120,
          renderer: function (v) { return ((v.public_cost_usd.toFixed(3)) + " $"); }
        },
        {
          text: _vm.$t('sms_history.col_receiver'),
          key: 'recipient',
          width: 160,
        } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }